module.exports = "../images/cabin-hero@2x.jpg?v=fccf8ee";